module.exports = __webpack_public_path__ + "static/media/5DPO21.efa84368.jpg";